export const ALUMNI_PLATFORM = {
	PAGES: {
		MAIN: {
			id: 25,
			title: 'SKOLKOVO Alumni Platform',
			slug: 'alumni-platform',
		},
		DIRECTORY: {
			id: 5,
			title: 'Директория выпускников',
			slug: 'direktoriia-vypusknikov',
		},
		CLUBS: {
			id: 15,
			title: 'Клубы выпускников',
			slug: 'kluby-vypusknikov',
		},
		COMMUNICATION_CHANNELS: {
			id: 25,
			title: 'Каналы коммуникаций',
			slug: 'kanaly-kommunikacii',
		},
		CHAPTERS: {
			id: 35,
			title: 'SKOLKOVO Alumni Chapters',
			slug: 'chapters',
		},
		CALENDAR_EVENTS: {
			id: 45,
			title: 'Календарь мероприятий',
			slug: 'kalendar-meropriiatii',
		},
		PHOTO_GALLERY: {
			id: 55,
			title: 'Фотогалерея',
			slug: 'fotogalereya',
		},
		OFFLINE_FEATURES: {
			id: 65,
			title: 'Офлайн возможности',
			slug: 'oflajn-vozmozhnosti',
		},
		MULTIMEDIA: {
			id: 75,
			title: 'Мультимедиа',
			slug: 'multimedia',
		},
		SHOP: {
			id: 85,
			title: 'SKOLKOVO Shop',
			slug: 'skolkovo-shop',
		},
		PRIVILEGE_PROGRAM: {
			id: 95,
			title: 'Программа привилегий',
			slug: 'programma-privilegii',
		},
		CONTACTS: {
			id: 105,
			title: 'Контакты',
			slug: 'alumni-contacts',
		},
		BACK_SCHOOL: {
			id: 115,
			title: 'Снова в школу',
			slug: 'snova-v-skolu',
		},
		DIRECTORY_SETTINGS: {
			id: 125,
			title: 'Настройки директории',
			slug: 'nastrojki-direktorii-vypusknikov',
		},
		BREAK_OUT: {
			id: 135,
			title: 'Забронировать брейк-аут',
			slug: 'book-breakout',
		},
	},
};
